import type { SelectedFilterOption } from 'src/types';
import { isSameFilterOption } from './isSameFilterOption';

export const updateSelectedFilterOptions = (
  filterOptions: SelectedFilterOption[],
  newFilterOption: SelectedFilterOption,
) =>
  filterOptions.map((filterOption: SelectedFilterOption) =>
    isSameFilterOption(filterOption, newFilterOption) ? newFilterOption : filterOption,
  );
